import { UserFile } from '@rsmu/portal-api';

export function constructImageDataUrl({ contentType, src }: UserFile): string {
  return `data:${contentType};base64,${src}`;
}
